export const WARRANTY_TYPE = {
  DEPOSIT: 'SECURITY_DEPOSIT',
  INSURANCE: 'INSURANCE',
}
